import { Injectable } from '@angular/core';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';
import { GetAllService } from '@app/shared/table/getAll.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddOrEditService {

  constructor(
    private api: ApiService,
    private util: UtilService,
    private getAllService: GetAllService
  ) {}

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }
  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      try {
        const decrypted = this.util.decrypt(value);
        return decrypted !== null && decrypted !== undefined ? decrypted : value;
      } catch (e) {
        return value;
      }
    }
    return null;
  }

  addOrEdit(module: any, data: any) {
    let requestBody = {
        ...data,
    }
    let postData: APIRequest = {}
    var postURL = '/addoredit/' + module;
    //console.log(module);
    switch (module) {
        case 'businessVertical':
            postData = {
                requestBody: {
                    ...requestBody,
                    organization_id: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'industryVertical':
            postData = {
                requestBody: {
                    ...requestBody,
                    organization_id: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'product':
            postData = {
                requestBody: {
                    ...requestBody,
                    organization_id: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'adminRole':
            const roleOrgId = (requestBody.organization_id !== undefined && requestBody.organization_id !== null)
                ? requestBody.organization_id
                : (this.orgID ? parseInt(this.orgID, 10) : -1);
            postData = {
                requestBody: {
                    ...requestBody,
                    organization_id: roleOrgId,
                }
            }
            break;
        case 'courseGroup':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'courseSubGroup':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'userCategoryAttributes':
            postData = {
                requestBody: {
                    ...requestBody,
                }
            }
            break;
        case 'userAttributesValues':
            postData = {
                requestBody: {
                    ...requestBody,
                }
            }
            break;
        case 'Mou':
        case 'userCategory':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgID: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'users':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'updateSalesLeadStatus':
            postData = {
                requestBody: {
                    ...requestBody,
                }
            }
            break;
        case 'courseModule':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'course':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'courseVersion':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;  
        case 'customerGroups':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break; 
        case 'opportunityMou':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'question':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10)
                }
            }
            break;
        case 'salesCustomer':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'salesOpportunity':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'questionPaperEvaluation':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'tag':
            postData = {
                requestBody: {
                    ...requestBody,
                    orgId: parseInt(this.orgID, 10),
                }
            }
            break;
        case 'awsBucketDetails':
        default:
            break;  
    }
    const cacheableModules = ['businessVertical', 'industryVertical', 'product'];
    if (cacheableModules.includes(module)) {
        return this.api.post(postURL, postData).pipe(
            tap(() => this.getAllService.clearSessionCache(module))
        );
    }
    return this.api.post(postURL, postData);
    }

    addOrEditMou(data){
   
        let requestBody = {
            ...data,
        }
         let postData = {
            requestBody: {
                ...requestBody,
            }
        }
        var postURL = '/addorEditMou';
        return this.api.post(postURL, postData);
    }

    addOrEditUpdateSalesLeadStatus(data){
        let requestBody = {
            ...data,
        }
         let postData = {
            requestBody: {
                ...requestBody,
            }
    }
    var postURL = '/updateStatus/salesLeadStatus';
    return this.api.post(postURL, postData);
}
}